import React from "react";
import "./Projects.css";
import Spin from "react-reveal/Spin";
import assets from "../../assets/online-exam-pic.png"; // Update the path as necessary
import mobileapp from "../../assets/mobile-app.webp"; // Update the path as necessary
import netflix from "../../assets/netflix.png"
import food from "../../assets/food.png"; // Update the path as necessary
import emoji from "../../assets/emoji.jpg"; // Update the path as necessary
import movie from "../../assets/movie.png"; // Update the path as necessary
const Projects = () => {
  return (
    <>
      <div className="continer project" id="projects">
        <h2 className="col-12 mt-3 mb-1 text-center text-uppercase">
          TOP RECENT PROJECTS
        </h2>
        <hr />
        <p className="pb-3 text-center">
          Here are some of the projects I’ve worked on — blending creativity, problem-solving, and clean code to build impactful solutions. Each one reflects my passion for technology and my journey of learning and growth.
        </p>
        {/* card design */}
        <div className="row" id="ads">
          <Spin>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Full stack</span>
                  <img
                    src={assets}
                    alt="project1"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">Node</span>
                  <span className="card-detail-badge">Express</span>
                  <span className="card-detail-badge">React</span>
                  <span className="card-detail-badge">Mongodb</span>
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h6 className="text-uppercase">
                      Online Examination System
                    </h6>
                  </div>
                  <a
                    className="ad-btn"
                    href="https://github.com/shilpa-maity/Online-Examination-System"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Mobile App</span>
                  <img
                    src={mobileapp}
                    alt="project2"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">React Native</span>

                  <span className="card-detail-badge">IOS / ANDROID</span>
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h5 className="text-uppercase">Employee Management App</h5>
                  </div>
                  <a
                    className="ad-btn"
                    href="https://github.com/shilpa-maity/Employee-Management-App"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Frontend</span>
                  <img
                    src={netflix}
                    alt="project1"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                  <span className="card-detail-badge">React.js</span>
                  
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h5 className="text-uppercase">Netflix Clone</h5>
                  </div>
                  <a className="ad-btn" href="https://github.com/shilpa-maity/react-netflix-clone">
                    View
                  </a>
                </div>
                
              </div>
            </div>
            
            
          </Spin>
         

          <Spin>
            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Full Stack</span>
                  <img
                    src={food}
                    alt="project2"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                   <span className="card-detail-badge">Node</span>
                  <span className="card-detail-badge">Express</span>
                  <span className="card-detail-badge">React</span>
                  <span className="card-detail-badge">Mongodb</span>
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h5 className="text-uppercase">Food Delivery Website</h5>
                  </div>
                  <a
                    className="ad-btn"
                    href="https://github.com/shilpa-maity/Food-Delivery-MERN"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Mechine Learning</span>
                  <img
                    src={emoji}
                    alt="project4"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                   <span className="card-detail-badge">Python</span>
                  <span className="card-detail-badge">ML</span>
                  
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h5 className="text-uppercase">Emojify-Create your own emoji</h5>
                  </div>
                  <a
                    className="ad-btn"
                    href="https://github.com/shilpa-maity/Emojify-Create-your-own-emoji_using-ML"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card rounded">
                <div className="card-image">
                  <span className="card-notify-badge">Mechine Learning</span>
                  <img
                    src={movie}
                    alt="project4"
                  />
                </div>
                <div className="card-image-overly m-auto mt-3">
                   <span className="card-detail-badge">Python</span>
                  <span className="card-detail-badge">ML</span>
                  
                </div>
                <div className="card-body text-center">
                  <div className="ad-title m-auto">
                    <h5 className="text-uppercase">Movie Review</h5>
                  </div>
                  <a
                    className="ad-btn"
                    href="https://github.com/shilpa-maity/Movie-Review-using-ML"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>
          </Spin>
          
        </div>
      </div>
    </>
  );
};

export default Projects;
